import { PublicClientApplication } from '@azure/msal-browser';

// MSAL Configuration for Azure AD Authentication
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AD_TENANT_ID || 'common'}`,
    redirectUri: process.env.ENTRA_REDIRECT_URI || process.env.REACT_APP_ENTRA_REDIRECT_URI || (typeof window !== 'undefined' ? window.location.origin + '/' : 'http://localhost:3000/'), // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
    // knownAuthorities: ["AugustSaysApp.ciamlogin.com/eba457b0-3b68-4542-b114-4cff62fcb4d4"],
    postLogoutRedirectUri: process.env.ENTRA_REDIRECT_URI || process.env.REACT_APP_ENTRA_REDIRECT_URI || (typeof window !== 'undefined' ? window.location.origin + '/' : 'http://localhost:3000/'),
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    // Prevent popup loops by adding retry logic
    allowRedirectInIframe: false,
    windowHashTimeout: 6000,
    iframeHashTimeout: 6000,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 2: // Error
            console.error(message);
            break;
          case 1: // Warning
            console.warn(message);
            break;
          case 0: // Info
            console.log(message);
            break;
          default:
            console.log(message);
        }
      },
    },
  },
};

// Create MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Login request scopes
export const loginRequest = {
  scopes: [process.env.REACT_APP_API_SCOPE || 'api://discovery-service/access_as_user'],
};

// Token request for API calls
export const tokenRequest = {
  scopes: [process.env.REACT_APP_API_SCOPE || 'api://discovery-service/access_as_user'],
};

// Protected API endpoints that require authentication
export const protectedResources = {
  discoveryApi: {
    scopes: [process.env.REACT_APP_API_SCOPE || 'api://discovery-service/access_as_user'],
  },
};
